// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.summary-box-wrapper {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(5rem, 1fr));
  justify-items: center;
  align-items: center;
  gap: 2rem;
  padding: 1rem;
}

@media (max-width: 768px) {
  .summary-box-wrapper {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
}

.summary-box {
  position: relative;
  padding: 1rem;
  background-color: #fff;
  box-shadow:
    0 10px 15px -3px rgba(0, 0, 0, 0.1),
    0 4px 6px -2px rgba(0, 0, 0, 0.05);
  border-radius: 20px;
  background: radial-gradient(
    165.94% 194.41% at 210.42% 137.41%,
    var(--blue) 0%,
    rgba(255, 255, 255, 0) 97.88%
  );
  width: 100%;
  transition: all 0.2s ease-in-out;
  border: 1px solid rgb(236, 236, 236);
  overflow: hidden;
}

.summary-box:before {
  background-image: var(--bg-image);
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transform: translate(5rem, 0);
  opacity: 0.08;
}

.summary-box:hover {
  transform: scale(1.05);
  box-shadow:
    0 15px 20px -5px rgba(0, 0, 0, 0.2),
    0 7px 10px -3px rgba(0, 0, 0, 0.1);
  border: 1px solid var(--blue);
}

.summary-box-title-box {
  display: flex;
  align-items: center;
  margin-bottom: 0.5rem;
  gap: 0.5rem;
}

.summary-box-icon-wrapper {
  width: 1.5rem;
  height: 1.5rem;
  padding: 0.5rem;
  border-radius: 50%;
  position: relative;
}

.summary-box-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #ffffff;
  height: 1.2rem !important;
}

.summary-box-amount {
  font-size: 2rem;
  font-weight: 800;
  line-height: 2.5rem;
}

.summary-box-title {
  font-size: 1.2rem;
  font-weight: 500;
  color: #404040;
}

.summary-box-orders {
  color: var(--blue);
  font-weight: 500;
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/sessionPage/components/SessionListing/components/SummaryCard/SummaryCard.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,0DAA0D;EAC1D,qBAAqB;EACrB,mBAAmB;EACnB,SAAS;EACT,aAAa;AACf;;AAEA;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;AACF;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB;;sCAEoC;EACpC,mBAAmB;EACnB;;;;GAIC;EACD,WAAW;EACX,gCAAgC;EAChC,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,wBAAwB;EACxB,2BAA2B;EAC3B,4BAA4B;EAC5B,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,6BAA6B;EAC7B,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB;;sCAEoC;EACpC,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB","sourcesContent":[".summary-box-wrapper {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(5rem, 1fr));\n  justify-items: center;\n  align-items: center;\n  gap: 2rem;\n  padding: 1rem;\n}\n\n@media (max-width: 768px) {\n  .summary-box-wrapper {\n    grid-template-columns: 1fr;\n    gap: 1rem;\n  }\n}\n\n.summary-box {\n  position: relative;\n  padding: 1rem;\n  background-color: #fff;\n  box-shadow:\n    0 10px 15px -3px rgba(0, 0, 0, 0.1),\n    0 4px 6px -2px rgba(0, 0, 0, 0.05);\n  border-radius: 20px;\n  background: radial-gradient(\n    165.94% 194.41% at 210.42% 137.41%,\n    var(--blue) 0%,\n    rgba(255, 255, 255, 0) 97.88%\n  );\n  width: 100%;\n  transition: all 0.2s ease-in-out;\n  border: 1px solid rgb(236, 236, 236);\n  overflow: hidden;\n}\n\n.summary-box:before {\n  background-image: var(--bg-image);\n  background-size: contain;\n  background-position: center;\n  background-repeat: no-repeat;\n  content: \"\";\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  transform: translate(5rem, 0);\n  opacity: 0.08;\n}\n\n.summary-box:hover {\n  transform: scale(1.05);\n  box-shadow:\n    0 15px 20px -5px rgba(0, 0, 0, 0.2),\n    0 7px 10px -3px rgba(0, 0, 0, 0.1);\n  border: 1px solid var(--blue);\n}\n\n.summary-box-title-box {\n  display: flex;\n  align-items: center;\n  margin-bottom: 0.5rem;\n  gap: 0.5rem;\n}\n\n.summary-box-icon-wrapper {\n  width: 1.5rem;\n  height: 1.5rem;\n  padding: 0.5rem;\n  border-radius: 50%;\n  position: relative;\n}\n\n.summary-box-icon {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  color: #ffffff;\n  height: 1.2rem !important;\n}\n\n.summary-box-amount {\n  font-size: 2rem;\n  font-weight: 800;\n  line-height: 2.5rem;\n}\n\n.summary-box-title {\n  font-size: 1.2rem;\n  font-weight: 500;\n  color: #404040;\n}\n\n.summary-box-orders {\n  color: var(--blue);\n  font-weight: 500;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
